import { configureStore, createListenerMiddleware } from "@reduxjs/toolkit";
import { widget } from "./api";
import RequestsReducer from "./slices/RequestsSlice";
import ProposalReducer from "./slices/ProposalSlice";
import GeneralReducer, {
  fetchInitData,
  setHeaders,
} from "./slices/GeneralSlice";
import RoomsReducer from "./slices/RoomsSlice";

export const listenerMiddleware = createListenerMiddleware();

export const store = configureStore({
  devTools: true,
  reducer: {
    [widget.reducerPath]: widget.reducer,
    requests: RequestsReducer,
    generalSettings: GeneralReducer,
    proposal: ProposalReducer,
    rooms: RoomsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: widget,
      },
      serializableCheck: false,
    })
      .prepend(listenerMiddleware.middleware)
      .concat(widget.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

listenerMiddleware.startListening({
  actionCreator: setHeaders,
  effect: async (action, listenerApi) => {
    // if (
    //   await listenerApi.condition((action, currentState: any) => {
    //     return (
    //       Object.keys(currentState.generalSettings.generalSettings).length === 0
    //     );
    //   })
    // ) {
    await listenerApi.dispatch(fetchInitData());
    // }
  },
});
